import { createApi } from 'unsplash-js'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const unsplash = createApi({
  // apiUrl: 'https://mywebsite.com/unsplash-proxy',
    accessKey: config.public.unsplashAPIKey,
  // ...other fetch options
  })

  return {
    provide: {
      unsplash,
    },
  }
})
